import BaseApiAction from "@Actions/base-api-action";

export default class GetRewards extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "rewards-getRewards",
      payload: {
        ...this.addFieldIfExists('ids', this._payload.ids,),
        ...this.addFieldIfExists('user_id', this._payload.user_id),
        ...this.addFieldIfExists('challenge_id', this._payload.challenge_id),
        ...this.addFieldIfExists('limit', this._payload.limit),
      },
    });
  }
}
